import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';

import { environment } from 'src/environments/environment';

export class ConfigService {
  constructor(private readonly http: HttpClient) { }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`,
      );
    }

    return throwError(() => new Error('Something bad happened; please try again later.'));
  }

  post<T>(service: string, data: unknown) {
    const httpOptions = data instanceof FormData
      ? {}
      : {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          }),
        };

    return this.http.post<T>(this.buildUrl(service), data, httpOptions);
  }

  put<T>(service: string, data: unknown) {
    return this.http.put<T>(
      this.buildUrl(service),
      data,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      },
    );
  }

  post_external<T>(url: string, data: unknown) {
    return this.http.post<T>(url, data, {
      headers: new HttpHeaders({
        'Content-Type': 'Content-Type: application/x-www-form-urlencoded',
      }),
    });
  }

  get<T>(service: string, responseType?: 'json' | 'blob') {
    return this.http.get<T>(this.buildUrl(service), {
      headers: new HttpHeaders({}),
      responseType: (responseType ?? 'json') as 'json',
    });
  }

  delete<T>(service: string) {
    return this.http.delete<T>(this.buildUrl(service), {
      headers: new HttpHeaders({}),
    });
  }

  private buildUrl(service: string): string {
    return `${environment.apiUrl}${service}`;
  }
}
